module.exports = __webpack_public_path__ + "static/media/usn-tub.a5194456.glb";